//export const baseUrl= "http://localhost:5000";

export const baseUrl= "https://attendence.sbsgroups.co.in:8000";